import { Component, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { Userprofile } from "src/app/_models/Userprofile";
import { GetOwnUserProfile } from "src/app/_store/user-profile/user-profile.actions";
import { selectOwnUserProfile } from "src/app/_store/user-profile/user-profile.selectors";
import { Roles } from "src/app/constants/Roles";

@Component({
  selector: "app-accessibility",
  templateUrl: "./accessibility.component.html",
  styleUrls: ["./accessibility.component.scss"]
})
export class AccessibilityComponent implements OnInit {

  isLoggedIn: boolean = false;
  userProfile$: Observable<Userprofile>;
  learnerRole: number = Roles.Learner;
  
  constructor(
    private authService: MsalService,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.authService.instance.getAllAccounts().length > 0;

    if(this.isLoggedIn) {
      this.dispatchGetOwnUserProfile();
      this.selectOwnUserProfile();
    }
  }

  dispatchGetOwnUserProfile(): void {
    this.store.dispatch(GetOwnUserProfile());
  }

  selectOwnUserProfile(): void {
    this.userProfile$ = this.store.select(selectOwnUserProfile);
  }
}
